const mutations = {
  SET_WISEPOPS (state, { wisepops }) {
    state.wisepops = wisepops
  }
}

export default mutations
